import React from "react";
import PropTypes from "prop-types";

import { withDraggableContext } from "../../hoc/withDraggableContext";
import ColumnSpacer from "../ColumnSpacer";

const TableRow = React.forwardRef(
  (
    {
      row,
      index,
      selectedRowProps,
      onClick,
      getRowProps,
      selectionCount,
      isDragging,
      stretchColumnWidth,
      ...props
    },
    ref
  ) => {
    const shouldShowSelection = isDragging && selectionCount > 1;

    return (
      <tr
        style={{
          position: "relative",
        }}
        {...row.getRowProps(getRowProps(row))}
        ref={ref}
        key={index}
        onClick={onClick}
        {...props}
      >
        {row.cells.map((cell, index) => (
          <td
            style={cell?.column?.style}
            {...cell.getCellProps()}
            key={index}
            id={`${row.id}_${cell.column.id}_${index}`}
          >
            {cell.render("Cell")}
          </td>
        ))}
        {shouldShowSelection ? (
          <div
            style={{
              right: "-10px",
              top: "-10px",
              background: "#438ded33",
              borderRadius: "50%",
              height: "25px",
              width: "25px",
              lineHeight: "25px",
              position: "absolute",
              textAlign: "center",
              fontSize: "0.7rem",
            }}
          >
            {selectionCount}
          </div>
        ) : null}
        {!stretchColumnWidth && <ColumnSpacer as="td" />}
      </tr>
    );
  }
);

TableRow.propTypes = {
  selectedRowProps: PropTypes.object,
  onClick: PropTypes.func,
  index: PropTypes.number,
  getRowProps: PropTypes.func,
  selectionCount: PropTypes.number,
  isDragging: PropTypes.bool,
  stretchColumnWidth: PropTypes.bool,
  row: PropTypes.shape({
    cells: PropTypes.array,
    allCells: PropTypes.array,
    getRowProps: PropTypes.func,
    toggleRowSelected: PropTypes.func,
    getToggleRowSelectedProps: PropTypes.func,
    index: PropTypes.number,
    id: PropTypes.string,
  }),
};

export default withDraggableContext(TableRow);
